// extracted by mini-css-extract-plugin
export default {"version-name-tooltip":"styles_version-name-tooltip__R+0hU","disabled":"styles_disabled__LBte1"};